module.exports = __webpack_public_path__ + "static/media/one-to-one-campaing.a18c25aa.jpeg";